import React from 'react'
import EledoButton, { ButtonSize, IconPosition } from './EledoButton'

const EledoComponents = () => {
  return (
    <div>
      <h1>EledoComponents</h1>
      <h3>Buttons</h3>
      <div>
        <p>Outlined</p>
        <EledoButton label={"Eledo"} tooltip="Tool tip" showTooltip={true} tooltipType='success' tooltipPosition='right'/>
        <EledoButton label={"Eledo"} color={'red'} />
        <EledoButton label={"Eledo"} color={'white'} />
        <EledoButton label={"Eledo"} color={'yellow'} />
      </div>
      <div>
        <p>primary</p>
        <EledoButton label={"Eledo"} primary={true}/>
        <EledoButton label={"Eledo"} primary={true} color={'red'} />
        <EledoButton label={"Eledo"} primary={true} color={'white'} />
        <EledoButton label={"Eledo"} primary={true} color={'yellow'} />
      </div>
      <div>
        <p>filled</p>
        <EledoButton label={"Eledo"} filled={true}/>
        <EledoButton label={"Eledo"} filled={true} color={'red'} />
        <EledoButton label={"Eledo"} filled={true} color={'white'} />
        <EledoButton label={"Eledo"} filled={true} color={'yellow'} />
      </div>
      <div>
        <p>noBorder</p>
        <EledoButton label={"Eledo"} noBorder={true}/>
        <EledoButton label={"Eledo"} noBorder={true} color={'red'} />
        <EledoButton label={"Eledo"} noBorder={true} color={'white'} />
        <EledoButton label={"Eledo"} noBorder={true} color={'yellow'} />
      </div>
      <div>
        <p>noSpace</p>
        <EledoButton label={"Eledo"} noSpace={true}/>
        <EledoButton label={"Eledo"} noSpace={true} color={'red'} />
        <EledoButton label={"Eledo"} noSpace={true} color={'white'} />
        <EledoButton label={"Eledo"} noSpace={true} color={'yellow'} />
      </div>
      <div>
        <p>rectangular</p>
        <EledoButton label={"Eledo"} rectangular={true}/>
        <EledoButton label={"Eledo"} rectangular={true} color={'red'} />
        <EledoButton label={"Eledo"} rectangular={true} color={'white'} />
        <EledoButton label={"Eledo"} rectangular={true} color={'yellow'} />
      </div>
      <div>
        <p>greenHover</p>
        <EledoButton label={"Eledo"} greenHover={true}/>
        <EledoButton label={"Eledo"} greenHover={true} color={'red'} />
        <EledoButton label={"Eledo"} greenHover={true} color={'white'} />
        <EledoButton label={"Eledo"} greenHover={true} color={'yellow'} />
      </div>
      <div>
        <p>size=SMALL</p>
        <EledoButton label={"Eledo"} size={ButtonSize.SMALL}/>
        <EledoButton label={"Eledo"} size={ButtonSize.SMALL} color={'red'} />
        <EledoButton label={"Eledo"} size={ButtonSize.SMALL} color={'white'} />
        <EledoButton label={"Eledo"} size={ButtonSize.SMALL} color={'yellow'} />
      </div>
      <div>
        <p>pending</p>
        <EledoButton label={"Eledo"} pendingState={true} pendingContent={"Loading"}/>
        <EledoButton label={"Eledo"} pendingState={true} pendingContent={"Loading"} color={'red'} />
        <EledoButton label={"Eledo"} pendingState={true} pendingContent={"Loading"} color={'white'} />
        <EledoButton label={"Eledo"} pendingState={true} pendingContent={"Loading"} color={'yellow'} />
      </div>
      <div>
        <p>pending & disabled</p>
        <EledoButton label={"Eledo"} pendingState={true} pendingContent={"Loading"} disable={true}/>
        <EledoButton label={"Eledo"} pendingState={true} pendingContent={"Loading"} disable={true} color={'red'} />
        <EledoButton label={"Eledo"} pendingState={true} pendingContent={"Loading"} disable={true} color={'white'} />
        <EledoButton label={"Eledo"} pendingState={true} pendingContent={"Loading"} disable={true} color={'yellow'} />
      </div>
      <div>
        <p>Icon position</p>
        <EledoButton label={"Eledo"} icon={"cog"} iconPosition={IconPosition.LEFT}/>
        <EledoButton label={"Eledo"} icon={"cog"} iconPosition={IconPosition.RIGHT} color={'red'} />
        <EledoButton label={"Eledo"} icon={"cog"} iconPosition={IconPosition.LEFT} color={'white'} />
        <EledoButton label={"Eledo"} icon={"cog"} iconPosition={IconPosition.RIGHT} color={'yellow'} />
      </div>
    </div>
  )
}

export default EledoComponents